import React from 'react';
import './ProductValue.css';

const features = [
  "Works directly inside your local Excel",
  "Shows every formula it writes",
  "Handles vague instructions",
  "Built for completing tasks, not explaining theory"
];

function ProductValue() {
  return (
    <section className="product-value section">
      <div className="container">
        <h2 className="section-title">What Makes Mica Powerful</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductValue;
